// extracted by mini-css-extract-plugin
module.exports = {"contents":"UpsellContent_contents__GncJ_","logo":"UpsellContent_logo__EbINI","heading":"UpsellContent_heading__duiX_"};